var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2493 17.9925L15.7154 13.4586C16.8069 12.0054 17.3962 10.2367 17.3942 8.4192C17.3942 3.77688 13.6173 0 8.97499 0C4.33267 0 0.555786 3.77688 0.555786 8.4192C0.555786 13.0615 4.33267 16.8384 8.97499 16.8384C10.7924 16.8404 12.5612 16.2512 14.0144 15.1596L18.5483 19.6935C18.7778 19.8986 19.0771 20.0081 19.3848 19.9995C19.6925 19.9909 19.9853 19.8648 20.2029 19.6472C20.4206 19.4295 20.5467 19.1367 20.5553 18.829C20.5639 18.5213 20.4544 18.222 20.2493 17.9925ZM2.96127 8.4192C2.96127 7.2298 3.31397 6.06711 3.97477 5.07816C4.63556 4.08921 5.57477 3.31842 6.67364 2.86325C7.7725 2.40809 8.98166 2.289 10.1482 2.52104C11.3147 2.75308 12.3863 3.32583 13.2273 4.16686C14.0684 5.00789 14.6411 6.07944 14.8731 7.24598C15.1052 8.41253 14.9861 9.62169 14.5309 10.7205C14.0758 11.8194 13.305 12.7586 12.316 13.4194C11.3271 14.0802 10.1644 14.4329 8.97499 14.4329C7.38064 14.431 5.85214 13.7968 4.72476 12.6694C3.59738 11.5421 2.96318 10.0135 2.96127 8.4192Z",
    fill: "#8E3B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e82f37ec271ed6415846e39daaa8f51f.svg";
export { ForwardRef as ReactComponent };